<template>
  <div class="selection-mortgage-overview">

    <div class="panel-footer">
      <div class="pagination-per-page-component">Per pagina
        <a-select v-model="perPage" @change="onPerPageChange">
          <a-select-option v-for="(option, index) in perPageOptions" :key="index" :value="option">
            {{ option }}
          </a-select-option>
        </a-select>

        <!--        <filter-component-->
        <!--            :staticSearch="staticSearch"-->
        <!--            @filter-request="getFilteredMortgages($event)"-->
        <!--        />-->
      </div>
    </div>

    <div class="panel-footer" v-if="displayPagination">
      <laravel-pagination :data="currentRequestData" @pagination-change-page="loadPage"></laravel-pagination>
    </div>

    <table class="table table-striped">
      <thead>
      <tr>
        <th>
          <!-- FIXME: Sorting by customer id, not by name! -->
          <!--          <order-by :order="order" :select="orderBy" value="customers.lastName" @change="onOrderByChange">-->
          Klant
          <!--          </order-by>-->
        </th>
        <th>Adres</th>
        <th>Contactgegevens</th>
        <th>Onderpandadres</th>
        <th class="compact">
          <order-by :order="order" :select="orderBy" value="passeerdatum" @change="onOrderByChange">Passeren</order-by>
        </th>
        <th class="w-auto">
          <order-by :order="order" :select="orderBy" value="marktwaarde" @change="onOrderByChange">Marktwaarde
          </order-by>
          <i class="mdi mdi-alert-circle-outline tooltip-toggle" data-toggle="tooltip" data-placement="right"
             title="Marktwaarde Geldverstrekker"> </i>
        </th>
        <th>
          <!-- FIXME: Sorting by agency id, not by name! -->
          <!--          <order-by :order="order" :select="orderBy" value="financier_agency_id" @change="onOrderByChange">-->
          Verstrekker
          <!--          </order-by>-->
        </th>
        <th>Product</th>
        <th>
          <order-by :order="order" :select="orderBy" value="hypotheeknummer" @change="onOrderByChange">Hypotheeknr.
          </order-by>
        </th>
        <th>
          <order-by :order="order" :select="orderBy" value="hypotheciareInschrijving" @change="onOrderByChange">
            Inschrijving
          </order-by>
        </th>

        <!--        TODO: make these columns sortable -->
        <th>
          <!--          <order-by :order="order" :select="orderBy" value="principal_sum" @change="onOrderByChange">-->
          Oorspronkelijk
          <!--          </order-by>-->
        </th>
        <th>
          <!--          <order-by :order="order" :select="orderBy" value="remaining_principal_sum" @change="onOrderByChange">-->
          Resterend
          <!--          </order-by>-->
        </th>
        <th>
          <!--          <order-by :order="order" :select="orderBy" value="remaining_interest_only_sum" @change="onOrderByChange">-->
          Aflosvrij
          <!--          </order-by>-->
        </th>
        <th>Labels</th>
      </tr>
      </thead>

      <SkeletonLoader v-if="loading" :rows="perPage" :columns="14"/>

      <tbody v-else>
      <template v-if="hasMortgages">
        <row-component v-for="mortgage in mortgages" :key="mortgage.id" :mortgage="mortgage"/>
      </template>
      <tr v-else>
        <td colspan=6>Geen zoekresultaten</td>
      </tr>
      </tbody>
    </table>

    <div class="panel-footer" v-if="displayPagination">
      <laravel-pagination :data="currentRequestData" @pagination-change-page="loadPage"></laravel-pagination>
    </div>
  </div>
</template>

<script>
import RowComponent from "./RowComponent";
import staticSelectionApi from '~/api/static_selection';
import FilterComponent from "./FilterComponent";
import SkeletonLoader from '../components/SkeletonLoader';

export default {
  name: "SelectionMortgageOverviewComponent",
  components: {
    RowComponent,
    FilterComponent,
    SkeletonLoader
  },
  props: {
    staticSearch: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      perPageOptions: [15, 30, 50],
      loading: true,
      reloadTimeout: null,
      currentPage: null,
      currentRequestData: null,
      page: 1,
      perPage: 15,
      orderBy: 'created_at',
      order: 'desc',
      filter: {},
      mortgages: [],
    }
  },
  mounted() {
    this.loadPage();
  },
  computed: {
    displayPagination() {
      return !this.loading && this.hasMortgages && this.hasPages && typeof this.currentRequestData.meta !== "undefined";
    },
    hasMortgages() {
      return this.mortgages.length > 0;
    },
    hasPages() {
      if (!this.loading) {
        return this.currentRequestData.meta.pagination.total_pages > 1;
      }
      return false;
    },
    currentTotalItemCount() {
      return (
          this.currentRequestData !== null && typeof this.currentRequestData.meta !== "undefined"
          && this.currentRequestData.meta !== null
          && typeof this.currentRequestData.meta.pagination !== "undefined"
          && this.currentRequestData.meta.pagination !== null
          && typeof this.currentRequestData.meta.pagination.total !== "undefined"
          && this.currentRequestData.meta.pagination.total !== null
      )
          ? this.currentRequestData.meta.pagination.total
          : null;
    },
  },
  methods: {
    loadPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) return;

      this.loading = true;
      staticSelectionApi.paginateByStaticSearch(
          this.staticSearch.key,
          page,
          this.perPage,
          this.orderBy,
          this.order,
          ['customer', 'customer.addresses', 'product_labels', 'agency'],
          this.filter,
          this.staticSearch.route_parameters
      ).then(response => {
        this.currentRequestData = response;
        this.mortgages = response.data;
        this.currentPage = page;
      }).catch(() => {
        this.$notification['error']({
          message: 'Er ging iets mis',
          description: `Het is niet gelukt om de selecties voor ${this.staticSearch.name} te laden.`,
        });
      })
          .finally(() => {
            this.loading = false;
          });
    },
    onOrderByChange(orderBy, order) {
      this.orderBy = orderBy;
      this.order = order;
      this.loadPage(this.currentPage, true);
    },
    onPerPageChange(value) {
      if (this.currentTotalItemCount !== null) {
        let newTotalPages = Math.ceil(this.currentTotalItemCount / value);

        if (this.currentPage > newTotalPages) {
          this.page = this.currentPage = 1;
        } else {
          this.page = this.currentPage;
        }
      } else {
        this.page = 1;
      }
      this.reloadPage();
    },
    reloadPage(page = null) {
      if (page === null) {
        this.page = this.currentPage;
      } else {
        this.page = page;
      }
      if (this.reloadTimeout !== null) {
        clearTimeout(this.reloadTimeout);
      }
      this.reloadTimeout = setTimeout(() => this.loadPage(this.page, true), 200);
    },
    getFilteredMortgages(params) {
      this.filter = params;
      this.loadPage(this.page, true);
    },
  }
}
</script>

<style scoped>
.table {
  margin-bottom: 0 !important;
}

.paginator {
  margin-left: 2rem;
}

.filters {
  display: inline-block;
  margin: 1rem 0 0 1rem;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}
</style>